import React, { useEffect } from "react";
import InfoBanner from "./InfoBanner";
import { logActivity } from "../utils/activity";

export default function FlowGuidanceBanner({ eventKey, title, description, meta }) {
  useEffect(() => {
    const storageKey = `myv_flow_guidance_${eventKey}`;
    if (localStorage.getItem(storageKey)) return;
    localStorage.setItem(storageKey, "true");
    logActivity("flow_guidance_shown", { key: eventKey, ...meta });
  }, [eventKey, meta]);

  return <InfoBanner title={title} description={description} />;
}
